import common from '@/common';
import { downloadBlob } from '@/utils/utils';
import { request } from '@umijs/max';

// 查询客户信息
export async function getBizCustByCustCodeService(params: any) {
  return request('/bcare/bizcust/cust', {
    params,
  });
}

// 查看订户数量接口
// export async function getMemberListQtyService(params: any) {
//   return request(`/bcare/member/list/qty/${params.custId}`);
// }
export async function getMemberListQtyService(params: any) {
  const { custId, ...restParams } = params;
  return common?.projectCode === 'pto'
    ? request('/bcare/bcc/bcMember/bcmemberCount', { params: restParams })
    : request(`/bcare/member/list/qty/${custId}`, {
        params: restParams,
      });
}

// 查看在途单数量
export async function getOrderListQtyService(params: any) {
  return request('/bcare/order/quantity', {
    params,
  });
}

// 查看企业客户账户数量
export async function getDepartmentInfoService(params: any) {
  const { custCode, ...restParams } = params;
  return request(`/bcare/accts/count/${custCode}`, {
    params: restParams,
  });
}

// 查询账户信控
export async function getCreditService(params: any) {
  return request(`/bcare/accts/credit/${params.acctId}`);
}

// 查询账户未缴费金额
export async function getBillAmountService(params: any) {
  return request(`/bcare/bill/balance/${params.acctId}`);
}

// 获取柱状图信息
export async function getServiceChargesService(params: any) {
  return request('/bcare/bill/service/charges', {
    params,
  });
}

// 保存企业客户头像
export async function updateBizCustInfoService(params: any) {
  const { custId, ...restParams } = params;
  return request(`/bcare/bizcust/modify/${custId}`, {
    method: 'PUT',
    data: restParams,
  });
}

// 批量导出member list
export async function exportMemberListService(data: any) {
  return request(`/bcare/tm/member/batch/export`, {
    method: 'POST',
    data,
    responseType: 'blob',
    skipErrorHandler: true,
    timeout: 50000,
  }).then((res) => {
    const typeMapping: Record<string, any> = {
      excel: [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'xlsx',
      ],
      text: ['text/plain', 'txt'],
    };

    const [type, suffix] = typeMapping[data?.docType];
    downloadBlob(res, type, `ExportMemberList.${suffix}`);
  });
}

// 查询有效的账户级账本
export async function getAcctBalService(data: any) {
  return request('/bcare/accts/queryAcctBal', {
    method: 'POST',
    data,
  });
}

// 支付接口
export async function getPaymentService(data: any) {
  return request('/bcare/homepage/webpay', {
    method: 'POST',
    data,
  });
}

// 查询订户各状态的数量
export async function getSubsStatisticsService(params: any) {
  const { custId, ...restParams } = params;
  return request(`/bcare/subs/statistics/${custId}`, {
    params: restParams,
  }).then((res) => res?.statistics || {});
}

// 查询客户下TT的总量、各状态数量
export async function getTicketStatisticsService(params: any) {
  const { custId, ...restParams } = params;
  return request(`/bcare/ticket/statistics/${custId}`, {
    params: restParams,
  });
}

// 查询首页年度流量
export async function getYearlyFlowService() {
  return request('/bcare/pto/dataConsume/queryYearlyConsume').then(
    (res) =>
      res?.yearlyDataConsumeDtoList?.map((item: any) => ({
        year: item.year,
        value: item.yearDataValue ? parseFloat(item.yearDataValue) : 0,
      })) || [],
  );
}
